import { nullishToOptional } from "../../../helpers";
import { DocumentationItemConfigurationV2 } from "./documentation-v2";
import { z } from "zod";
export const DocumentationPageDataV2 = z.object({
    configuration: nullishToOptional(DocumentationItemConfigurationV2),
});
